export default function getImageUrl(image) {
  // 1. No image provided → use placeholder
  if (!image) return "https://via.placeholder.com/800x500?text=No+Image";

  // 2. If image is already a full URL, return it as-is
  if (image.startsWith("http://") || image.startsWith("https://")) {
    return image;
  }

  // 3. Otherwise, treat it as a filename and prepend the base URL
  const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;
  return `${imageBaseUrl.replace(/\/$/, "")}/${image}`;
}
